module.exports = __webpack_public_path__ + "a0bcb805e1bcee6a81abbcddbcded99a.svg";